// MainAppContext — expone el estado y handlers de MainApp a los componentes
// extraídos para reducir prop drilling y tamaño de App.js.
// Creado en Feb 2026 (Fase 2 del refactor).
import { createContext, useContext } from "react";

export const MainAppContext = createContext(null);

export const useMainApp = () => {
  const ctx = useContext(MainAppContext);
  if (ctx === null) {
    throw new Error("useMainApp debe usarse dentro de <MainAppContext.Provider>");
  }
  return ctx;
};
